import {createApp} from 'vue'
import PIMap from './PIMap'

const el = '.nyk-component--pi-map'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PIMapDOM)=>{
            const props = {
                labels: PIMapDOM.dataset.labels ? JSON.parse(PIMapDOM.dataset.labels) : null,
                mapkey: PIMapDOM.dataset.mapkey,
                isBusiness: PIMapDOM.dataset.isBusiness === 'true',
                startLatitude: PIMapDOM.dataset.startLatitude ? parseFloat(PIMapDOM.dataset.startLatitude) : 56.27206,
                startLongitude: PIMapDOM.dataset.startLongitude ? parseFloat(PIMapDOM.dataset.startLongitude) : 10.3,
                availableBanks: PIMapDOM.dataset.availableBanks ? JSON.parse(PIMapDOM.dataset.availableBanks) : null,
                centerInformation: PIMapDOM.dataset.centerInformation ? JSON.parse(PIMapDOM.dataset.centerInformation) : null,
            }
            const component = createApp(PIMap, props).use(Store)
            component.mount(PIMapDOM)
        })
    }
}